import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "list" ]

  connect() {
    this.scrollToBottom()
    // Observe additions to the messages list to scroll automatically
    this.observer = new MutationObserver(() => this.scrollToBottom())
    if (this.hasListTarget) {
      this.observer.observe(this.listTarget, { childList: true })
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  scrollToBottom() {
    if (this.hasListTarget) {
      this.listTarget.scrollTop = this.listTarget.scrollHeight
    }
  }
}
